const LOGIN = 'LOGIN';
const GETHEATS = 'GETHEATS';
const GETHEATDETAILS = 'GETHEATDETAILS';
const UPDATEEVENTSTATE = 'UPDATEEVENTSTATE';
const CONNECT = 'CONNECT';
const SENDHEARTBEAT = 'SENDHEARTBEAT';
const SENDHEATGROUP = 'SENDHEATGROUP';
const SENDRESULT = 'SENDRESULT';
const SETHEATGROUPSTATUS = 'SETHEATGROUPSTATUS';
const SENDCURRENTCURSOR = 'SENDCURRENTCURSOR';
const AUTODROP = 'AUTODROP';
const SENDWKBHELP = 'SENDWKBHELP';
const SAVEENTRYCHANGES = 'SAVEENTRYCHANGES';
const REQUESTPOOLMERGEAVAILABLE = 'REQUESTPOOLMERGEAVAILABLE';
const SENDPOOLMERGE = 'SENDPOOLMERGE';

export default {
    CONNECT,
    LOGIN,
    GETHEATS,
    GETHEATDETAILS,
    UPDATEEVENTSTATE,
    SENDHEARTBEAT,
    SENDHEATGROUP,
    SENDRESULT,
    SETHEATGROUPSTATUS,
    SENDCURRENTCURSOR,
    AUTODROP,
    SENDWKBHELP,
    SAVEENTRYCHANGES,
    REQUESTPOOLMERGEAVAILABLE,
    SENDPOOLMERGE,
};